import { useFormikContext } from 'formik';
import { debounce } from 'lodash';
import { useEffect, useMemo } from 'react';

export function AutoSave(): null {
  const formik = useFormikContext();

  const save = useMemo(
    () => debounce(formik.handleSubmit, 500),
    [formik.handleSubmit]
  );

  useEffect(() => {
    if (formik.dirty && formik.isValid) {
      save();
    }
  }, [formik.values, save, formik.isValid, formik.dirty]);

  return null;
}
